import { RefObject, Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// Models
import IInsuranceCase from 'app/models/Case';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectCasesList, selectCasesHasMore, selectCasesGettingMore } from 'app/store/Cases/Cases.selectors';
// Mui
import { Box } from '@mui/material';
// Components
import { Loader, Message } from 'app/components/Utilities';
// Hooks
import useIntersectionObserver from 'app/hooks/useIntersectionObserver';
// 
import CasesListItem from './CasesListItem';
import CasesNoData from './CasesNoData';
import useCasesContext from './utils/useCasesContext';

const CasesList = () => {
  const { t } = useTranslation();
  // State
  const insuranceCases:IInsuranceCase[] | null = useAppSelector(selectCasesList);
  const hasMore:boolean = useAppSelector(selectCasesHasMore);
  const gettingMore:boolean = useAppSelector(selectCasesGettingMore);

  const { params, onChangeParams } = useCasesContext();
  const [ targetRef, isIntersecting ] = useIntersectionObserver({});

  useEffect(() => {
    if ( !isIntersecting ) return;
    if ( !hasMore ) return;

    const offset = params.offset + params.limit;

    onChangeParams({ ...params, offset });
    // eslint-disable-next-line
  }, [isIntersecting]);

  if ( !insuranceCases ) return <Loader />;
  if ( params.search && !insuranceCases.length ) return <Message text={t('pages.cases.noDataFound')} />;
  if ( !insuranceCases.length ) return <CasesNoData />;
  return (
    <Fragment>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {insuranceCases.map((insuranceCase:IInsuranceCase, index:number) => (
          <Fragment key={`case item ${insuranceCase.id}`}>
            <CasesListItem insuranceCase={insuranceCase} />
            {index === insuranceCases.length - 1 ? (
              <span ref={targetRef as RefObject<HTMLSpanElement>} />
            ) : null}
          </Fragment>
        ))}
      </Box>
      {gettingMore ? <Loader /> : null}
    </Fragment>
  )
}

export default CasesList;
